// Single source of truth for stacking order (STYLE-002). Apply these as inline
// `style={{ zIndex: Z_LAYERS.X }}` rather than Tailwind `z-[...]` classes:
// arbitrary/interpolated z- classes built from these constants at runtime
// generate no CSS (the JIT scanner can't see runtime values), which is how the
// old sort-menu z-index silently did nothing.
export const Z_LAYERS = {
  // Decorative gradients painted behind all app content.
  BACKGROUND: -2,
  BASE: 0,
  // Content stacked above a same-parent (unlayered) backdrop/gradient.
  CONTENT: 1,
  // Prompt cards.
  CARD: 1,
  // Per-card action menu + its trigger button.
  MENU_BUTTON: 10,
  // Dropdown panels (sort menu).
  DROPDOWN: 20,
  // Header dropdowns (folder dropdown) — above content/dropdowns, below modals.
  HEADER_DROPDOWN: 25,
  // Modal dialogs: confirm/input dialogs, premium dialog, the prompt form.
  MODAL: 30,
  // Toasts float above modals.
  TOAST: 40,
  // Collapsed-sidebar hover tooltips.
  TOOLTIP: 45,
  // Variable-fill form overlay (a modal that can open above the prompt form).
  VARIABLE_FORM: 50,
  // A secondary overlay opened above an existing modal (e.g. the prompt form's
  // inner confirmation).
  NESTED_MODAL: 60,
} as const;

export type ZLayer = keyof typeof Z_LAYERS;
